import { IconButton } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { colors, responsive } from '@/utils';

/** Card content beside the sidebar should keep clear of this width so the sidebar does not hide it. */
export const CARD_SIDEBAR_WIDTH = '3rem';

/**
 * Vertical action strip on the right edge of a card, shown while the card is hovered or focused.
 * It must be a direct child of the card, and the card must be `position: relative`.
 */
export const StyledCardSidebar = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Keeps the layout card's four small buttons, plus the spacer's extra gap, inside its 10rem. */
  gap: ${responsive.spacing.small};
  width: ${CARD_SIDEBAR_WIDTH};
  padding: ${responsive.spacing['2xlarge']} 0;
  border-left: 1px solid ${colors.stroke.neutral.soft['50']};
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
  background-color: ${colors.background.info.soft['50']};
  cursor: default;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;

  *:hover > &,
  *:focus-within > & {
    opacity: 1;
    pointer-events: auto;
  }

  /*
   * A tap cannot hover first, so on any touch screen the actions are always shown. any-pointer
   * also covers touch laptops, which report the mouse as their primary pointer.
   */
  @media (hover: none), (any-pointer: coarse) {
    opacity: 1;
    pointer-events: auto;
  }
`;

/** IconButton paints its icon in the neutral colour, so the icon colour is set on the svg itself. */
export const StyledCardSidebarButton = styled(IconButton)<{ $destructive: boolean }>`
  && svg {
    color: ${({ $destructive }) =>
      $destructive ? colors.icon.alarm['100'] : colors.icon.info.on.soft['100']};
  }
`;

/**
 * Pushes the buttons after it to the bottom of the sidebar. Grouping is done here, not with nested
 * flex wrappers in each card, so every card that reuses the sidebar only lists its buttons.
 */
export const CardSidebarSpacer = styled.div`
  flex: 1;
`;
